module.exports = __webpack_public_path__ + "static/example-multi-mobile-bbb5aa67c7e2f414cc9a238991e4c765.png";